import { Component, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './shared/auth/auth.service';
import { IdleCheckerService } from './shared/services/idle-checker.service';
import { MessagingService } from './shared/services/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  public message: BehaviorSubject<null>;

  constructor(private router: Router, private authService: AuthService,
    private idleCheckerService: IdleCheckerService,
    private messagingService: MessagingService) {
  }

  ngOnInit(): void {

    this.messagingService.receiveMessage();


    // Enviar ping de actividad cada X segundos
    this.idleCheckerService.sendPingEvery(900);

    // Ping solo activo para doctores actualmente
    if (this.authService.panelType === 'doctor' &&
      this.authService.user.doctor !== undefined) {

      this.idleCheckerService.startPinging();

    }


    this.subscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => window.scrollTo(0, 0));



    const publicRoutes = [
      '/gracias-por-su-compra'
    ];

    const isPublic = publicRoutes.some(
      route => window.location.pathname.startsWith(route)
    );

    if (!isPublic) {
      this.authService.init();
    }
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


}
